import script from "./AdminOrderList.vue?vue&type=script&setup=true&lang=js"
export * from "./AdminOrderList.vue?vue&type=script&setup=true&lang=js"

import "./AdminOrderList.vue?vue&type=style&index=0&id=30bc8328&scoped=true&lang=css"
import "./AdminOrderList.vue?vue&type=style&index=1&id=30bc8328&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-30bc8328"]])

export default __exports__